import React, {FunctionComponent, ReactNode} from 'react'
//import React from "react";

interface ProductItemsProps {
    items: (string | ReactNode)[];
    label?: string | ReactNode | null | undefined;
    className?: string;
    emptyLabel?: string;
}

const ProductItems: FunctionComponent<ProductItemsProps> = ({items, label = "Sections", className="", emptyLabel="Empty"}) => {
    if (!items) {
        return null
    }

    return (
        <div className={`text-text-md pl-md pr-lg py-sm bg-primary-25 rounded-md shadow border border-primary-500 justify-start items-center flex flex-row gap-xs h-[50px] ${className}`}>

            <div className={"flex flex-col "}>

                {label &&
                    <div className="text-primary-600 text-xs">
                        {label}
                    </div>
                }



                <div className={"flex flex-row gap-xs justify-center item-center h-[100%]"} style={{ alignItems: "center"}}>
                    {items.map((item:string | ReactNode, index) => (
                        <React.Fragment key={index}>
                            <span className="flex flex-row gap-xs">{item}</span>
                            {index !== items.length - 1 && (
                                <span className="font-icon-light text-primary-400 flex justify-center items-center h-full min-h-full">-</span>
                            )}
                        </React.Fragment>
                    ))}
                    {items.length === 0 && (
                        <div className={"text-gray-400"}>
                            {emptyLabel}
                        </div>
                    )}
                </div>


            </div>

        </div>


    )
}

export default ProductItems
